import { render, staticRenderFns } from "./RecapModal.vue?vue&type=template&id=36533e42&scoped=true"
import script from "./RecapModal.vue?vue&type=script&lang=ts"
export * from "./RecapModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36533e42",
  null
  
)

export default component.exports